import { ButtonGeneral, ButtonSecondary, typographyRem } from '@by-miles/bymiles-styles'
import React, { useContext } from 'react'

import { ProviderContext } from '../../../../../Provider'
import { GenericOverlay } from '../../../../Overlays'
import { AdditionalDriversStyle } from '../AdditionalDriversStyle'
const { h2: H2, paragraphBody: ParagraphBody } = typographyRem

interface RemoveDriverModalProps {
  onRemove: () => void
  name: string
}

export const RemoveDriverModal = ({ onRemove, name }: RemoveDriverModalProps) => {
  const { handleCloseModal } = useContext(ProviderContext)

  return (
    <AdditionalDriversStyle>
      <GenericOverlay
        onClose={() => handleCloseModal('remove-additional-driver')}
        overlay={
          <>
            <H2>Remove additional driver.</H2>
            <div className="modal-info-container">
              <ParagraphBody className="modal-info">
                {`Are you sure you want to remove ${name} from your quote?`}
              </ParagraphBody>
              <ParagraphBody className="modal-info">
                Any details you have entered for them will not be saved.
              </ParagraphBody>
            </div>
            <div className="remove-driver-button-container">
              <ButtonGeneral
                icon="Alert"
                label="Remove driver"
                onClick={() => {
                  onRemove()
                  handleCloseModal('remove-additional-driver')
                }}
                dataCy="confirm-remove-additional-driver"
                className="modal-button"
              />
              <ButtonSecondary
                label="Keep driver"
                onClick={() => handleCloseModal('remove-additional-driver')}
                dataCy="confirm-remove-additional-driver"
                className="keep-driver-button modal-button"
              />
            </div>
          </>
        }
      />
    </AdditionalDriversStyle>
  )
}
